module.exports = __webpack_public_path__ + "img/full2-min.ebd2eef2.png";